import React from 'react';
import { useToasts } from '../context/ToastContext';

// 单个 Toast 组件
const Toast = ({ message, type, onRemove }) => {
  const baseStyle = {
    padding: '12px 18px',
    margin: '0 0 10px',
    borderRadius: '6px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 500,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '320px',
    opacity: 0.95,
    transition: 'all 0.3s ease-in-out',
  };

  const typeStyles = {
    info: { background: 'var(--brand-primary, #007bff)' },
    success: { background: 'var(--success-color, #28a745)' },
    error: { background: 'var(--danger-color, #dc3545)' },
    warning: { background: 'var(--warning-color, #ffc107)', color: '#212529' },
  };

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    color: 'inherit',
    fontSize: '18px',
    cursor: 'pointer',
    marginLeft: '15px',
    lineHeight: 1,
  };

  return (
    <div style={{ ...baseStyle, ...typeStyles[type] }}>
      <span>{message}</span>
      <button onClick={onRemove} style={closeButtonStyle}>&times;</button>
    </div>
  );
};

// Toast 容器组件
const ToastContainer = () => {
  const { toasts, removeToast } = useToasts();

  const containerStyle = {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 1050,
  };

  if (!toasts.length) {
    return null;
  }

  return (
    <div style={containerStyle}>
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onRemove={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
